import React, { useEffect } from 'react';
import { useWorkspaceMap } from './hooks/WorkspaceMap.hook';
import { useSelector } from 'react-redux';
import { isMexico } from '@/helpers/locationHelpers';
import { FlexContainer } from '@/components/containers/FlexContainer/FlexContainer';
import WorkspaceMapView from './views/WorkspaceMapView';
import StillBuildingHomeView from '@/components/pages/StillBuilding/views/StillBuildingHomeView';
import SearchView from '@/components/pages/Search/views/SearchView';
import LoadingComponent from '@/components/general/Loading/LoadingComponent';

const WorkspaceMapController = () => {
  const searchFormData = useSelector(state => state.searchFormData);
  const currencyData = useSelector(state => state.currency);
  const location = useSelector(state => state.location?.data);
  const lenguage = useSelector(state => state.lenguage?.lang);
  const isFromMexico = isMexico(location);
  const {
    isLoading,
    workspacesDataFromBackend,
    isSignInModalIsOpen,
    closeSignInModal,
    closeWarningModal,
    isWarningModalIsOpen,
    coordinatesForMapCenter,
    onClickMarkers,
    onSwiperInit,
    loginWithGoogleOAuth,
  } = useWorkspaceMap(searchFormData, currencyData, isFromMexico);

  const handleGoogleLogin = async ({ email, googleToken }) => {
    return loginWithGoogleOAuth({ username: email, googleToken });
  };

  if (isLoading) {
    return <LoadingComponent loading={isLoading} />;
  } else {
    return (
      <>
        <FlexContainer className={'flex-column width100 d-hide'}>
          <WorkspaceMapView
            workspacesDataFromBackend={workspacesDataFromBackend}
            isSignInModalIsOpen={isSignInModalIsOpen}
            closeSignInModal={closeSignInModal}
            closeWarningModal={closeWarningModal}
            isWarningModalIsOpen={isWarningModalIsOpen}
            coordinatesForMapCenter={coordinatesForMapCenter}
            onClickMarkers={onClickMarkers}
            onSwiperInit={onSwiperInit}
            onGoogleLogin={handleGoogleLogin}
          />
        </FlexContainer>
        <FlexContainer className={'flex-column width100 m-hide'}>
          <SearchView
            spacesDataFromBackend={workspacesDataFromBackend}
            lenguage={lenguage}
            currencyData={currencyData}
            coordinatesForMapCenter={coordinatesForMapCenter}
            onClickMarkers={onClickMarkers}
            isSignInModalIsOpen={isSignInModalIsOpen}
            closeSignInModal={closeSignInModal}
            closeWarningModal={closeWarningModal}
            isWarningModalIsOpen={isWarningModalIsOpen}
            onSwiperInit={onSwiperInit}
            onGoogleLogin={handleGoogleLogin}
          />
        </FlexContainer>
      </>
    );
  }
};

export default WorkspaceMapController;
